import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
var Restrictions = function () {
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", children: "Restrictions" }), _jsx(Typography, { children: "Manage booking restrictions and policies" })] }));
};
export default Restrictions;
